/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { LazyImage } from "@website/ui/lazy-image";
import { isChannel } from "@website/utils/channel/helpers";
import { numberConvert } from "@website/utils/number-convert";
import { replaceSnappTripBasedOnChannel } from "@website/utils/title-replace";
import { FooterRow } from "@website/widget/footer/footer-row";
import {
  applications,
  contactUs,
  copyright,
  snappSocialMediaLinks,
  socialMediaLinks,
  support
} from "@website/widget/footer/footer.constants";
import { useFooter } from "@website/widget/footer/footer.hook";
import styles from "@website/widget/footer/footer.module.scss";
import { FooterPropertiesType } from "@website/widget/footer/footer.types";
import { FC } from "react";

export const FooterComponent: FC<FooterPropertiesType> = (properties) => {
  const {
    minimalView,
    isShowSupportNumber = !isChannel(["b2b"]),
    isShowBolderPlateLinks = !isChannel(["b2b"]),
    hasB2BContact = isChannel(["b2b"]),
    hasDownloadApp = !isChannel(["b2b", "snapp-ir"])
    // hasLinkBadge = !isChannel(["b2b", "snapp-ir"] ,channel)
  } = properties;
  const {
    certificates,
    // categories,
    links,
    moreInfo,
    services
    // linksBadgs
  } = useFooter();

  return (
    <footer className={styles["footer"]}>
      {isShowSupportNumber && (
        <FooterRow>
          <div className={styles["support"]}>
            <div className={styles["support-title"]}>
              پشتیبانی ۲۴ ساعته و ۷ روز هفته
            </div>
            <div className={styles["support-phone"]}>
              <a
                className={styles["support-phone-text"]}
                href={`tel:${support.phoneNumber.value}`}
              >
                {numberConvert(support.phoneNumber.text, {
                  numberOnly: false,
                  locale: "fa"
                })}
              </a>
              <div className={styles["support-phone-icon"]}>
                <MaterialIcon name="phone" />
              </div>
            </div>
          </div>
        </FooterRow>
      )}
      {!minimalView && isShowBolderPlateLinks && (
        <FooterRow>
          <div className={styles["links"]}>
            {!isChannel(["snapp-ir"]) && (
              <div className={styles["links-column"]}>
                <div className={styles["links-column-title"]}>
                  خدمات مسافرتی
                </div>
                <div className={styles["links-column-list"]}>
                  {services.map((item) => (
                    <a
                      className={styles["links-column-item"]}
                      href={item.url}
                      key={item.url}
                    >
                      {item.title}
                    </a>
                  ))}
                </div>
              </div>
            )}
            {!isChannel(["snapp-ir"]) && (
              <div className={styles["links-column"]}>
                <div className={styles["links-column-title"]}>امکانات</div>
                <div className={styles["links-column-list"]}>
                  {links.map((item) => (
                    <a
                      className={styles["links-column-item"]}
                      href={item.url}
                      itemScope
                      key={`${item?.title}-${item?.url}`}
                    >
                      {item.title}
                    </a>
                  ))}
                </div>
              </div>
            )}
            {/* <div className={styles["links-column"]}>
            <div className={styles["links-column-title"]}>
              {"دسته بندی ها"}
            </div>
            <div className={styles["links-column-list"]}>
              {categories.map((item, index) => (
                <a
                  href={item.url}
                  key={index}
                  className={styles["links-column-item"]}
                >
                  {item.title}
                </a>
              ))}
            </div>
          </div> */}
            <div className={styles["links-column"]}>
              <div className={styles["links-column-title"]}>اطلاعات بیشتر</div>
              <div className={styles["links-column-list"]}>
                {moreInfo.map((item) => (
                  <a
                    className={styles["links-column-item"]}
                    href={item.url}
                    itemScope
                    key={item?.url}
                  >
                    {item.title}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </FooterRow>
      )}

      <FooterRow>
        <div className={styles["contact"]}>
          <div className={styles["contact-us"]}>
            <div className={styles["contact-us-title"]}>ارتباط با ما</div>

            {!hasB2BContact && (
              <>
                <div className={styles["contact-us-item"]}>
                  <div className={styles["contact-us-item-key"]}>آدرس</div>
                  <div className={styles["contact-us-item-value"]}>
                    {isChannel(["snapp-ir"])
                      ? "تهران، زعفرانیه، خیابان شهید فلاحی، تقاطع خیابان مقدس اردبیلی، پلاک ۲"
                      : "بلوار نلسون ماندلا، تقاطع آرش غربی، نبش کوچه ایرج، پلاک ۱۱۵"}
                  </div>
                </div>
                <div className={styles["contact-us-item"]}>
                  <div className={styles["contact-us-item-key"]}>کد پستی:</div>
                  <div className={styles["contact-us-item-value"]}>
                    {numberConvert(contactUs.zipCode, {
                      numberOnly: false,
                      locale: "fa"
                    })}
                  </div>
                </div>
                <div className={styles["contact-us-item"]}>
                  <div className={styles["contact-us-item-key"]}>تلفن:</div>
                  <div className={styles["contact-us-item-value"]}>
                    <a
                      href={`tel:${contactUs.phoneNumbers[0].value}`}
                      itemScope
                    >
                      {numberConvert(contactUs.phoneNumbers[0].text, {
                        numberOnly: false,
                        locale: "fa"
                      })}
                    </a>
                    &nbsp; - &nbsp;
                    <a
                      href={`tel:${contactUs.phoneNumbers[1].value}`}
                      itemScope
                    >
                      {numberConvert(contactUs.phoneNumbers[1].text, {
                        numberOnly: false,
                        locale: "fa"
                      })}
                    </a>
                    &nbsp; (
                    {numberConvert(contactUs.phoneNumberPrefix, {
                      numberOnly: false,
                      locale: "fa"
                    })}
                    )
                  </div>
                </div>
              </>
            )}
            {hasB2BContact && (
              <>
                <div className="text-on-surface-high-emphasis mt-1 flex items-center gap-4">
                  پشتیبانی ۲۴ ساعته و ۷ روز هفته
                  <a dir="ltr" href="tel:02192000123">
                    ۰۲۱ ۹۲۰۰۰۱۲۳ (داخلی ۳)
                  </a>
                </div>

                <div className={styles["contact-us-item"]}>
                  <div className={styles["contact-us-item-key"]}>آدرس:</div>
                  <div className={styles["contact-us-item-value"]}>
                    {isChannel(["snapp-ir"])
                      ? "تهران، زعفرانیه، خیابان شهید فلاحی، تقاطع خیابان مقدس اردبیلی، پلاک ۲"
                      : "بلوار نلسون ماندلا، تقاطع آرش غربی، نبش کوچه ایرج، پلاک ۱۱۵"}
                  </div>
                </div>
              </>
            )}
          </div>
          <div className={styles["social-media"]}>
            <div className={styles["social-media-title"]}>شبکه های اجتماعی</div>
            <div className={styles["social-media-description"]}>
              با ما در ارتباط باشید
            </div>
            <div className={styles["social-media-list"]}>
              {(isChannel(["snapp-ir"])
                ? snappSocialMediaLinks
                : socialMediaLinks
              ).map((item) => (
                <Button
                  EndIcon={item.icon}
                  aria-label={item.ariaLabel}
                  className={styles["social-media-item"]}
                  color="neutral"
                  equalDimension
                  href={item.url}
                  key={item.url}
                  rel={item.rel}
                  role="link"
                  size="x-small"
                  target="_blank"
                  variant="text"
                />
              ))}
            </div>
          </div>
        </div>
      </FooterRow>
      {!minimalView && hasDownloadApp && (
        <FooterRow>
          <div className={styles["download-app"]}>
            <div className={styles["download-app-content"]}>
              <div className={styles["download-app-title"]}>
                دانلود اپلیکیشن
              </div>
            </div>
            <div className={styles["download-app-list"]}>
              {applications.map((item) => (
                <a
                  className={styles["download-app-item"]}
                  href={item?.url}
                  itemScope
                  key={item?.url}
                  rel="noreferrer nofollow"
                  target="_blank"
                >
                  {item?.image && (
                    <LazyImage
                      alt={item?.alt}
                      height={item?.height}
                      loading="lazy"
                      src={item?.image}
                      width={item?.width}
                    />
                  )}
                </a>
              ))}
            </div>
          </div>
        </FooterRow>
      )}
      <FooterRow>
        <div className={styles["about-us"]}>
          <div className={styles["about-us-content"]}>
            <div className={styles["about-us-title"]}>
              {replaceSnappTripBasedOnChannel("درباره ی اسنپ تریپ")}
            </div>
            <div className={styles["about-us-description"]}>
              {replaceSnappTripBasedOnChannel(
                "در اسنپ تریپ با چند کلیک می‌توانید پروازها و اقامتگاه‌های مختلف را بررسی کرده و با انتخاب مناسب‌ترین گزینه‌ها سفر خوشی را تجربه کنید."
              )}
            </div>
          </div>
          <div className={styles["about-us-list"]}>
            {certificates.map((item) => (
              <div className={styles["about-us-item"]} itemScope key={item?.id}>
                {item?.src && <LazyImage {...item} />}
              </div>
            ))}
          </div>
        </div>
      </FooterRow>
      {/* {hasLinkBadge && (
        <FooterRow>
          <div className={styles["badgs"]}>
            {linksBadgs?.map((badgs) => (
              <Button
                className={styles["button"]}
                color="neutral"
                href={badgs.url}
                key={badgs.title}
                role="link"
                text={badgs.title}
                variant="round-outline"
              />
            ))}
          </div>
        </FooterRow>
      )} */}
      <FooterRow background="gray">
        <div className={styles["copyright"]}>
          <div className={styles["copyright-item"]}>
            از مطالب این وب‌سایت فقط می‌توانید برای مقاصد غیرتجاری و با ذکر منبع
            استفاده کنید.
            {!isChannel(["snapp-ir"]) &&
              " تمامی حقوق این وب‌سایت به شرکت آرا جهان نوین گستر اطلس تعلق دارد."}
          </div>
          <div className={styles["copyright-item"]}>{copyright.sign}</div>
        </div>
      </FooterRow>
    </footer>
  );
};
